import { environSyncsAction, thermoSmartsAction, weatherSensorsAction } from "../actionTypes"
import { jflApi } from "../../common/authApi";

export const loadWeather=(data)=>{
    return {
        type:weatherSensorsAction.LOAD,
        payload:data
    }
}



export const loadThermoSmart=(data)=>{
    return {
        type:thermoSmartsAction.LOAD,
        payload:data
    }
}


export const loadEnviroSynnc=(data)=>{
    return {
        type:environSyncsAction.LOAD,
        payload:data
    }
}

// POST /v1/devices/details - schedule and state for a batch of devices, in one
// call. This is what the Device Schedule page reads its current/expected
// schedule objects from; the store assets route only names the devices.
//
// A 403 "Missing Authentication Token" from here is API Gateway's reply for a
// path that does not exist, not an auth failure - it is named in the error
// below because the two are indistinguishable by status alone.
export const fetchDeviceDetails = async (deviceIds) => {
  try {
    const response = await jflApi.post("/v1/devices/details", { deviceIds });

    const payload = response.data?.data ?? {};
    // The response shape is unconfirmed, so accept the plausible shapes rather
    // than assuming one: a bare array, or an object holding the array.
    const rows = Array.isArray(payload)
      ? payload
      : payload.devices ?? payload.details ?? payload.schedules ?? [];

    return { success: true, data: rows, raw: response.data };
  } catch (error) {
    const status = error.response?.status;

    return {
      success: false,
      // The undeployed-route 403 is indistinguishable from a real auth error by
      // status alone, so name it: otherwise this reads as "you are logged out".
      message:
        status === 403 &&
        error.response?.data?.message === "Missing Authentication Token"
          ? "The device details API is not available yet (route not deployed)."
          : error.response?.data?.error?.errorMessage ||
            error.response?.data?.message ||
            error.message ||
            "Could not load device details",
    };
  }
};

// Every asset's deviceId for a store, flattened out of the areas that
// fetchStoreAssets shaped into rooms. Deduplicated, because the same device can
// appear under more than one area.
export const deviceIdsFromHouseData = (houseData) => {
  const ids = (houseData?.rooms ?? []).flatMap((room) =>
    (room.energiSync ?? []).map((device) => device.deviceId)
  );

  return [...new Set(ids.filter(Boolean))];
};
